import * as turf from './turf';

class AreaManager {
    constructor(mapState) {
        this.mapState = mapState;
    }

    selectArea(area) {
        const selectedAreas = [...this.mapState.getSelectedAreas()];
        if (!selectedAreas.find(a => a.properties.id === area.properties.id)) {
            selectedAreas.push({
                ...area
            });
            this.mapState.setSelectedAreas(selectedAreas);
        }
    }

    toggleArea(area) {
        const selectedAreas = this.mapState.getSelectedAreas() || [];
        const areaId = area.properties.id;
        const existingIndex = selectedAreas.findIndex(a => a && a.properties && a.properties.id === areaId);

        let newSelectedAreas;
        if (existingIndex === -1) {
            // Area not selected, add it
            newSelectedAreas = [...selectedAreas, area];
        } else {
            // Area already selected, remove it
            newSelectedAreas = selectedAreas.filter((_, index) => index !== existingIndex);
        }

        // Update the state with new selected areas
        this.mapState.setSelectedAreas(newSelectedAreas);
        return newSelectedAreas;
    }

    convertSelectedToCurrentSelectionAreas(areaOuter) {
        let removeAreas = [];
        const selectedAreas = [...this.mapState.getSelectedAreas()];
            
        selectedAreas.forEach(areaInner => {
            const polyOuter = areaOuter.geometry.type === 'GeometryCollection' ? 
                turf.multiPolygon(areaOuter.geometry.geometries.map(g => g.coordinates)) : 
                turf.polygon(areaOuter.geometry.coordinates);
            const polyInner = areaInner.geometry.type === 'GeometryCollection' ? 
                turf.multiPolygon(areaInner.geometry.geometries.map(g => g.coordinates)) : 
                turf.polygon(areaInner.geometry.coordinates);
            
            if (areaOuter.properties.type.indexOf('zip') > -1 && 
                areaInner.properties.type.indexOf('zip') > -1 && 
                areaOuter.properties.type !== areaInner.properties.type && 
                turf.intersect(polyOuter, polyInner)) {
                if (turf.area(polyOuter) > turf.area(polyInner)) {
                    removeAreas = [...removeAreas, areaInner.id];
                } else {
                    removeAreas = [...removeAreas, areaOuter.id];
                }
            } 
        });

        const filteredAreas = selectedAreas.filter(a => !removeAreas.includes(a.id));
        this.mapState.setSelectedAreas(filteredAreas);
    }
}

export default AreaManager; 